import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import { QuickInsertTextArea, ReactSelect, required, ToggleField } from "modules/4_final_form/web";
import BasicModal from "modules/5_view_helpers/web/BasicModal";
import { getAddressBookCompanies } from "modules/address_book/companies/actions";
import { getEmployees } from "modules/employees/actions";
import { getProjectStatuses } from "modules/project/statuses/actions";
import { getUserManagements } from "modules/user_managements/actions";
import React, { Fragment, useEffect } from "react";
import { Field, useFormState } from "react-final-form";
import { connect } from "react-redux";
import { Button, Card, CardBody, CardHeader, Col, Collapse, FormGroup, Label } from "reactstrap";

function mapStateToProps(state) {
  return {
    users: state.users,
  };
}

const ActionsAttributes = (props) => {
  const { fields, inputs, users } = props;

  useEffect(() => {
    props.getUserManagements();
  }, []);

  const removeAction = (index) => {
    const thisValues = fields.value[index];

    if (thisValues.id) {
      fields.update(index, {
        ...thisValues,
        _destroy: true,
      });
    } else {
      fields.remove(index);
    }
  };

  return (
    <div>
      <b>Actions</b>

      <Button
        onClick={() => {
          fields.forEach((field, index) => {
            fields.update(index, {
              ...fields.value[index],
              open: false,
            });
          });

          fields.push({
            open: true,
            project_manager_actual: false,
            site_manager_actual: false,
            detailer_actual: false,
          });
        }}
        className="ml-2"
        size="sm"
      >
        Add Action
      </Button>

      {fields.map((field, index) => {
        const thisValues = fields.value[index];
        if (thisValues._destroy) return null;

        return (
          <ActionFields
            field={field}
            key={index}
            fields={fields}
            index={index}
            values={thisValues}
            inputs={inputs}
            users={users}
            removeAction={() => {
              removeAction(index);
            }}
          />
        );
      })}

      {_.isEmpty(fields.value) && <div className="mt-2">No actions</div>}
    </div>
  );
};

export default connect(mapStateToProps, { getUserManagements })(ActionsAttributes);

const ActionFields = (props) => {
  const { field, index, values, removeAction, fields, inputs, users } = props;
  const { open, name, action_type, project_field } = values;

  console.log(project_field)

  let include_attachments = false;
  let include_report = false;

  const formValues = useFormState().values;
  const parent_type = formValues.parent_type;
  let action_types = [{ label: "Send Email", value: "send_email" }];

  let snippets = _.map(_.compact(inputs), (input) => {
    return { label: input.label || input.name, value: `{{${input.name}}}` };
  });

  snippets.push({ label: "id", value: "{{id}}" });
  snippets.push({ label: "Created Date/Time", value: "{{created_at}}" });
  snippets.push({ label: "Author Name", value: "{{author}}" });

  if (!parent_type || parent_type == "CustomForm") {
    snippets.push({ label: "Custom Form Unique Number", value: "{{custom_form_number}}" });
    snippets.push({ label: "Parent Unique Number", value: "{{parent_number}}" });
    include_attachments = true;
    include_report = true;
  }


  if (parent_type == "Project" || project_field) {
    snippets.push({ label: "Project Name", value: "{{project_name}}" });
    snippets.push({ label: "Project Manager", value: "{{project_manager}}" });
    snippets.push({ label: "Site Manager", value: "{{site_manager}}" });
    snippets.push({ label: "Detailer", value: "{{detailer}}" });
  }

  let special_users = [{ value: "Author", label: "Author" }];
  if (parent_type == "Project" || parent_type == "Project::Qa::Site::Surveillance" || project_field) {
    special_users.push({ value: "Project_Manager", label: "Project_Manager" });
    special_users.push({ value: "Site_Manager", label: "Site_Manager" });
    special_users.push({ value: "Detailer", label: "Detailer" });
    include_report = true;
  }

  if (parent_type == "Project::Twr") {
    action_types.push({ label: "Edit Project", value: "edit_project" });
  }

  const toggle = () => {
    fields.update(index, {
      ...fields.value[index],
      open: !open,
    });
  };

  let project_names = _.filter(inputs, { column_type: "project" }).map((input) => { return { label: input.name, value: input.name } });

  return (
    <Card className="mt-2">
      <CardHeader
        onClick={toggle}
        style={{
          cursor: "pointer",
        }}
      >
        <Col>{action_type || "New Action"}</Col>
        <Col>
          <BasicModal
            buttonLabel="Remove Action"
            buttonColor="danger"
            successButtonLabel="Yes"
            onSuccessClick={() => {
              removeAction(index);
            }}
            title={`Remove Action`}
          >
            Are you sure you want to remove this Action?
          </BasicModal>
        </Col>
      </CardHeader>
      <Collapse isOpen={open}>
        <CardBody>
          <FormGroup row>
            <Label md={2}>Type</Label>
            <Col md={4}>
              <Field component={ReactSelect} name={`${field}.action_type`} options={action_types} validate={required} />
            </Col>
          </FormGroup>
          {action_type == "send_email" && (
            <SendEmailActionFields
              snippets={snippets}
              fields={fields}
              users={users}
              special_users={special_users}
              field={field}
              parent_type={parent_type}
              include_report={include_report}
              include_attachments={include_attachments}
              project_names={project_names}
            />
          )}
          {action_type == "edit_project" && (
            <EditProjectActionFields
              snippets={snippets}
              fieldIndex={index}
              inputs={inputs}
              fields={fields}
              users={users}
              special_users={special_users}
              field={field}
            />
          )}
        </CardBody>
      </Collapse>
    </Card>
  );
};

const SendEmailActionFields = (props) => {
  const { field, special_users, snippets, users, parent_type, include_report, include_attachments, project_names } = props;
  return (
    <Fragment>
      <FormGroup row>
        <Label sm={2}>User/s to notify</Label>
        <Col sm={9}>
          <Field
            component={ReactSelect}
            multi
            sendDestroy
            name={`${field}.users_attributes`}
            options={_.map(users, (u) => ({
              label: u.name,
              value: u.id,
              user_id: u.id,
            }))}
          />
        </Col>
      </FormGroup>
      {parent_type != "Project" && (
        <FormGroup row>
          <Label sm={2}>Project Field for special users</Label>
          <Col sm={9}>
            <Field component={ReactSelect} options={project_names} name={`${field}.project_field`} />
          </Col>
        </FormGroup>
      )}
      <FormGroup row>
        <Label sm={2}>Special user/s to notify</Label>
        <Col sm={9}>
          <Field component={ReactSelect} multi sendDestroy name={`${field}.special_users_attributes`} options={special_users} />
        </Col>
      </FormGroup>

      <FormGroup row>
        <Label sm={2}>Subject</Label>
        <Col sm={9}>
          <Field component={QuickInsertTextArea} rows="1" name={`${field}.email_subject_template`} snippets={snippets} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={2}>Email Template</Label>
        <Col md={10}>
          <Field component={QuickInsertTextArea} name={`${field}.email_body_template`} snippets={snippets} validate={required} />
        </Col>
      </FormGroup>
      {(include_report || include_attachments) && (
        <FormGroup row>
          {include_report && (
            <Fragment>
              <Label md={2}>Include Report in email</Label>
              <Col md={1}>
                <Field name={`${field}.email_include_report`} component={ToggleField} />
              </Col>
            </Fragment>
          )}

          {include_attachments && (
            <Fragment>
              <Label md={2}>Include Attachments in email</Label>
              <Col md={1}>
                <Field name={`${field}.email_include_attachments`} component={ToggleField} />
              </Col>
            </Fragment>
          )}
        </FormGroup>
      )}
    </Fragment>
  );
};

const mapStateToPropsForProject = (state) => ({
  users: state.users,
  employees: state.employees,
  production_strumis_contracts: state.production_strumis_contracts,
  project_statuses: state.project_statuses,
  address_book_companies: state.address_book_companies,
});

let EditProjectActionFields = (props) => {
  useEffect(() => {
    props.getUserManagements(true);
    props.getProjectStatuses();
    props.getEmployees();
    props.getAddressBookCompanies();
  }, []);

  const { users, field, project_statuses, fields, inputs, fieldIndex, address_book_companies } = props;

  const thisField = fields.value[fieldIndex];
  let thisFieldData = _.cloneDeep(thisField?.data) || {};
  const { project_manager_actual, site_manager_actual, detailer_actual, company_actual } = thisFieldData;

  const display_project_statuses = _.filter(project_statuses, { role: 1 });
  const be_project_statuses = _.filter(project_statuses, { role: 2 });
  const hlr_project_statuses = _.filter(project_statuses, { role: 3 });
  const se_project_statuses = _.filter(project_statuses, { role: 3 });

  const project_inputs = _.filter(inputs, { column_type: "project" });
  const employee_inputs = _.filter(inputs, { column_type: "employee" });
  const user_inputs = _.filter(inputs, { column_type: "user" });
  const company_inputs = _.filter(inputs, { column_type: "company" });

  const users_options = _.map(users, (e) => {
    return { label: e.name, value: e.id };
  });

  const project_inputs_options = _.map(project_inputs, (e) => {
    return { label: e.label, value: e.name };
  });

  const employee_inputs_options = _.map(employee_inputs, (e) => {
    return { label: e.label, value: e.name };
  });

  const user_inputs_options = _.map(user_inputs, (e) => {
    return { label: e.label, value: e.name };
  });

  const company_options = _.map(address_book_companies, (e) => {
    return { label: e.name, value: e.id };
  });

  const company_inputs_options = _.map(company_inputs, (e) => {
    return { label: e.label, value: e.name };
  });

  const project_manager_placeholder = project_manager_actual ? "Select Project Manager..." : "Select Form Input...";
  const site_manager_placeholder = site_manager_actual ? "Select Site Manager..." : "Select Form Input...";
  const detailer_placeholder = detailer_actual ? "Select Detailer..." : "Select Form Input...";
  const company_placeholder = company_actual ? "Select Client Company..." : "Select Form Input...";

  const handleSwitchToFormInputs = (field) => {
    const field_id_name = field.replace("_actual", "_id");

    // Nullify the related field_id
    let thisFieldData = _.cloneDeep(thisField?.data);
    thisFieldData[field_id_name] = null;
    thisFieldData[field] = !thisFieldData[field];

    fields.update(fieldIndex, {
      ...fields.value[fieldIndex],
      data: thisFieldData,
    });
  };

  return (
    <Fragment>
      <FormGroup row>
        <Label md={2}>Project to edit</Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            options={project_inputs_options}
            name={`${field}.data.project_field`}
            placeholder="Select Form Input for the project to edit"
            validate={required}
          />
        </Col>
      </FormGroup>

      <hr />
      <FormGroup row>
        <Label md={2}>
          Client Company{" "}
          <FontAwesomeIcon
            icon={faExchangeAlt}
            style={{ cursor: "pointer" }}
            title="Switch to Form Inputs"
            onClick={() => handleSwitchToFormInputs("company_actual")}
          />
        </Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            options={company_actual ? company_options : company_inputs_options}
            name={`${field}.data.company_id`}
            placeholder={company_placeholder}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={2}>
          Project manager{" "}
          <FontAwesomeIcon
            icon={faExchangeAlt}
            style={{ cursor: "pointer" }}
            title="Switch to Form Inputs"
            onClick={() => handleSwitchToFormInputs("project_manager_actual")}
          />
        </Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            options={project_manager_actual ? users_options : user_inputs_options}
            name={`${field}.data.project_manager_id`}
            placeholder={project_manager_placeholder}
          />
        </Col>
        <Label md={2}>
          Site manager{" "}
          <FontAwesomeIcon
            icon={faExchangeAlt}
            style={{ cursor: "pointer" }}
            title="Switch to Form Inputs"
            onClick={() => handleSwitchToFormInputs("site_manager_actual")}
          />
        </Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            options={site_manager_actual ? users_options : user_inputs_options}
            name={`${field}.data.site_manager_id`}
            placeholder={site_manager_placeholder}
          />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label md={2}>
          Detailer{" "}
          <FontAwesomeIcon
            icon={faExchangeAlt}
            style={{ cursor: "pointer" }}
            title="Switch to Form Inputs"
            onClick={() => handleSwitchToFormInputs("detailer_actual")}
          />
        </Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            options={detailer_actual ? users_options : user_inputs_options}
            name={`${field}.data.detailer_id`}
            placeholder={detailer_placeholder}
          />
        </Col>
      </FormGroup>

      <hr />
      <h5>Status</h5>
      <FormGroup row>
        <Label md={2}>Project Status</Label>
        <Col md={4}>
          <Field
            component={ReactSelect}
            options={_.map(display_project_statuses, (e) => {
              return { label: e.name, value: e.id };
            })}
            name={`${field}.data.status_id`}
            placeholder="Select Project Status..."
          />
        </Col>
      </FormGroup>

      <Fragment>
        <FormGroup row>
          <Label md={2}>Business Evaluation Status</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(be_project_statuses, (e) => {
                return { label: e.name, value: e.id };
              })}
              name={`${field}.data.be_status_id`}
              placeholder="Select Business Evaluation Status..."
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>High Level Review Status</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(hlr_project_statuses, (e) => {
                return { label: e.name, value: e.id };
              })}
              name={`${field}.data.hlr_status_id`}
              placeholder="Select HLR Status..."
            />
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label md={2}>Submit Estimation Status</Label>
          <Col md={4}>
            <Field
              component={ReactSelect}
              options={_.map(se_project_statuses, (e) => {
                return { label: e.name, value: e.id };
              })}
              name={`${field}.data.se_status_id`}
              placeholder="Select Estimation Status..."
            />
          </Col>
        </FormGroup>
      </Fragment>

      <hr />
      <FormGroup row>
        <Label md={2}>Archived</Label>
        <Col md={4}>
          <Field component={ToggleField} name={`${field}.data.archived`} />
        </Col>
      </FormGroup>
    </Fragment>
  );
};

EditProjectActionFields = connect(mapStateToPropsForProject, { getEmployees, getUserManagements, getProjectStatuses, getAddressBookCompanies })(
  EditProjectActionFields
);
